import { keyframes } from "styled-components";
import styled from "styled-components";
import { NavLink } from "react-router-dom";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const TilesPersonSection = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 24px;
  padding: 16px 0;
  width: 100%;
  animation: ${fadeIn} 0.5s ease-out forwards;

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 16px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  }
`;

export const StyledNavLink = styled(NavLink)`
  text-decoration: none;
  width: 100%;
  color: ${({ theme }) => theme.color.white};
  
  transition: all 0.3s ease;
     ${props => props.isSoon && `
     pointer-events: none;
  `}
  &:hover {
    ${props => !props.isSoon && `
      transform: translateY(-4px);
    `}
  }
`;
export const Wrapper = styled.div`

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  // background:rgb(31, 31, 31);
   background:rgb(46, 46, 46);
  border-radius: 8px;
  transition: all 0.3s ease;
  height: 100%;
    ${props => props.isSoon && `
      background: rgb(73, 73, 73);
     pointer-events: none;
  `}
  &:hover {
     background:${({ theme }) => theme.color.spotifyLightGrey};
cursor: pointer;
    transform: scale(1.02);
  }
`;

export const StyledTilePerson = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const PosterWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 100%;
  border-radius: 8px;
  overflow: hidden;
 box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
`;

export const Poster = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  transition: transform 0.3s ease;
  ${Wrapper}:hover & {
    transform: scale(1.05);
  }
`;

export const NoPoster = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #535353 0%, #282828 100%);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #444 0%, #222 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;

  svg {
    width: 50%;
    height: 50%;
    opacity: 0.9;
    transition: all 0.3s ease;
    transform: scale(1); /* Ustawienie bazowe */
  }

  /* Efekt hover dla wszystkich ikon */
  ${Wrapper}:hover & svg {
    transform: scale(1.05);
  }

  /* Style dla ikon standardowych */
  &[data-premium="false"] svg {
    fill: #E2E0DA;
    color: #E2E0DA;
  }
  ${Wrapper}:hover &[data-premium="false"] svg {
    filter: drop-shadow(0 0 4px rgba(15, 201, 15, 0.5));
  }

  /* Style dla ikon premium */
  &[data-premium="true"] svg {
    fill: url(#premium-icon-gradient);
    color: url(#premium-icon-gradient);
  }
  ${Wrapper}:hover &[data-premium="true"] svg {
    filter: drop-shadow(0 0 4px rgba(255, 219, 77, 0.5));
  }
`;

export const StyledPersonIcon = styled.div`
  width: 50%;
  opacity: 0.8;
  color: #b3b3b3;
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-height: 62px;
  width: 100%;
`;

export const PersonNameStyle = styled.div`
  color: ${({ theme }) => theme.color.white};
  font-size: 16px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    font-size: 14px;
  }
`;

export const PersonRole = styled.div`
  color: #b3b3b3;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    font-size: 12px;
  }
`;

export const PremiumBadge = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  background: linear-gradient(90deg, #ffdb4d 0%, #ff8c00 100%);
  color: #000;
  font-size: 10px;
  font-weight: 700;
  padding: 4px 8px;
  border-radius: 12px;
  z-index: 2;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
     ${props => props.isSoon && `
    background: linear-gradient(90deg,rgb(182, 171, 129) 0%,rgb(177, 128, 72) 100%);
  `}
`;


export const SectionTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  padding: 16px 0;
   color: ${({ theme }) => theme.color.text};
    ${props => props.isPremium && `
    background: linear-gradient(90deg, #ffdb4d 0%, #ff8c00 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  `}
  margin-bottom: 16px;
  letter-spacing: -0.5px;
  position: relative;
  display: inline-block;

  &::after {
    content: '';
    position: absolute;
    bottom: 8px;
    left: 0;
    width: 40px;
    height: 3px;
    background: linear-gradient(90deg, #1db954 0%, rgba(29, 185, 84, 0) 100%);
    border-radius: 3px;
  }
`;